define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/profiles/profilesGridView.tmpl");
    var ProfilesGridRowView = require("user-management-views/profiles/ProfilesGridRowView");
    var ProfilesGridEmptyView = require("user-management-views/profiles/ProfilesGridEmptyView");

    var ProfilesGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        ProfilesGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: ProfilesGridRowView,
            emptyView: ProfilesGridEmptyView,

            onCompositeCollectionRendered:function(){
                LEUserManagement.logger.debug("onCompositeCollectionRendered", "ProfilesGridView::onCompositeCollectionRendered");
                _.each(this.collection.getSelected(), function(selectedModel){
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        selectedModel.trigger("model:selection:change", true);
                    }
                }, this);
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfilesGridView;
});
